import { mapGetters, mapMutations } from "vuex";
import Multiselect from "vue-multiselect";

import EditOwner from "./../Owner/edit.vue";
import EditProperty from "./../Common/editProperty.vue";
import EditVehicle from "./../Common/editVehicle.vue";
import EditAddress from "./../Common/editAddress.vue";
import EditInsuranceReqRCA from "./../Common/editInsuranceReqRCA.vue";
import EditInsuranceReqBuilding from "./../Common/editInsuranceReqBuilding.vue";
import EditInsuranceReqGeneral from "./../Common/editInsuranceReqGeneral.vue";

import Offers from "./offersComponent.vue";
import SelectedOffer from "./selectedOfferComponent.vue";
import OfferComponent from "./offerComponent.vue";

import { userService } from '../../services/UserService';
import { orderService } from '../../services/OrderService'
import { EventBus } from '@/event-bus';

export default {
    name: "EditOrder",

    components: {
        Multiselect,
        EditOwner,
        EditProperty,
        EditVehicle,
        EditAddress,
        EditInsuranceReqRCA,
        EditInsuranceReqBuilding,
        EditInsuranceReqGeneral,
        Offers,
        SelectedOffer,
        OfferComponent
    },

    data: () => {
        return {
            loading: true,
            saving: false,
            offerSaved: false,
            cachingOffer: false,
            tabIndex: 0,
            //
            action: "",
            orderTypeId: -1,
            orderSettings: {
                JsonSettings: {
                    PropertyType: 0
                }
            },

            currentOrderId: 0,

            orderCachekey: "",
            //
            offers: [],

            propertyType: 0,

            //
            users: [],
            selectedUser: {},
            //
            termsAgreed: false,
            canSaveOffer: false,
            //
            dismissSecs: 30,
            dismissCountDown: 30,
            showDismissibleAlert: true,
            discountPrc: 0,
            customOptions: {},
        };
    },

    created() {
        // make sure the settings are loaded
        this.$store.dispatch("general/getSettings");
        this.$store.dispatch("general/getOrderTypeSettings").then(() => {
            this.loadOrder();
        });

    },
    mounted() {
        this.dismissCountDown = this.dismissSecs = 30;
    },

    beforeDestroy() {
        this.clearOrder();
    },

    computed: {
        ...mapGetters({
            // general
            typeSettings: "general/typeSettings",

            // order
            order: "order/order",
            orderLoaded: "order/orderLoaded",
            orderEditable: "order/orderEditable",

            // user
            userHasRole: "user/hasRole",
            profile: "user/profile",

            //custom options
            orderCustomOptions: "order/customOptions"
        }),

        isValid() {
            return !this.$v.$anyError;
        },

        roles() {
            return userService.roles;
        },

        canHandleOrders() {
            return (
                this.userHasRole(this.roles.admin) ||
                this.userHasRole(this.roles.operator)
            );
        },

        termsValidState() {
            return this.termsAgreed === true || this.order.Status >= 2;
        },

        calculateOfferButtonText() {
            //if (this.orderSettings.JsonSettings.PropertyType === 0) {
            //    return "Solicita oferta";
            //} else if (this.orderSettings.JsonSettings.PropertyType === 1) {
            //    return "Calculeaza oferta...";
            //} else {
            //    return "Salveaza";
            //}

            if (this.orderSettings.Description == 'RCA') {
                return "Calculeaza oferta...";
            }
            else {
                return "Solicita oferta";
            }
        }
    },

    methods: {
        ...mapMutations({
            clearOrder: "order/clear",
            setCurrentOrderId: "order/setCurrentOrderId",
            setCurrentOrderType: "order/setCurrentOrderType",
            setCurrentOrderStatus: "order/setCurrentOrderStatus",
            setCurrentOrderUser: "order/setCurrentOrderUser",
            setCurrentOrderCacheKey: "order/setCurrentOrderCacheKey",
            setOrderLoaded: "order/setOrderLoaded",
            setOffers: "order/setOffers",
            setCustomOptions: "order/setCustomOptions"
        }),
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },

        validate: function () {
            var ownerIsValid = this.$refs.editOwner.validate();
            console.log("ownerIsValid = " + ownerIsValid);

            var propertyIsValid = true,
                propertyReqIsValid = true;
            var vehicleIsValid = true,
                vehicleReqIsValid = true;
            var offerIsValid = true;

            if (this.orderSettings.JsonSettings.PropertyType == 0) {
                propertyIsValid = this.$refs.editProperty.validate();

                if (this.order.Status > 2) {
                    offerIsValid = this.$refs.offerComponent.validate();
                } else if (this.order.Status < 2) {
                    if (this.orderTypeId == 2) { // Locuinta
                        propertyReqIsValid = this.$refs.editInsuranceReqBuilding.validate();
                    }
                    else {
                        propertyReqIsValid = this.$refs.editInsuranceReqGeneral.validate();
                    }
                }
            }
            else if (this.orderSettings.JsonSettings.PropertyType == 1) {
                vehicleIsValid = this.$refs.editVehicle.validate();
                console.log("vehicleIsValid = " + vehicleIsValid);
                // for confirmed offers we chould validate offer component
                if (this.order.Status > 2) {
                    offerIsValid = this.$refs.offerComponent.validate();
                    console.log("offerIsValid = " + offerIsValid);
                } else if (this.order.Status < 2) {
                    if (this.orderTypeId == 1) { // RCA
                        vehicleReqIsValid = this.$refs.editInsuranceReqRCA.validate();
                    }
                    else {
                        vehicleReqIsValid = this.$refs.editInsuranceReqGeneral.validate();
                    }

                    console.log("vehicleReqIsValid = " + vehicleReqIsValid);
                }
            }
            else {
                if (this.order.Status > 2) {
                    offerIsValid = this.$refs.offerComponent.validate();
                }
                else {
                    offerIsValid = this.$refs.editInsuranceReqGeneral.validate();
                }
            }

            var result =
                ownerIsValid &&
                this.termsAgreed &&
                propertyIsValid &&
                propertyReqIsValid &&
                vehicleIsValid &&
                vehicleReqIsValid &&
                offerIsValid;

            return result;
        },

        allOffersReceived: function () {
            this.canSaveOffer = true;
        },

        getOrderIcon(orderTypeId) {
            var icon = "fa fa-cubes";
            switch (orderTypeId) {
                case 1: // RCA
                    icon = "fa fa-car";
                    break;
                case 2: // Locuinta
                    icon = "fa fa-building-o";
                    break;
                default:
                    icon = "fa fa-car";
                    break;
            }
            return icon;
        },

        loadOrder() {
            this.clearOrder();

            var orderType = 0;
            var orderId = 0;
            var renewOrder = false;
            var tempOrder = false;
            // Add order
            if (
                this.$route.name === "addOrder" ||
                this.$route.name === "RCA" ||
                this.$route.name === "Locuinta" ||
                this.$route.name === "CASCO"
            ) {
                orderType = parseInt(this.$route.params.type);
            }
            // edit order
            if (
                this.$route.name === "editOrder" ||
                this.$route.name === "viewOrder"
            ) {
                orderId = parseInt(this.$route.params.id);
            }
            // edit offer
            if (
                this.$route.name === "editOffer" ||
                this.$route.name === "viewOffer"
            ) {
                orderId = parseInt(this.$route.params.id);
                tempOrder = true;
            }
            // renew order
            if (this.$route.name === "renewOrder") {
                orderId = parseInt(this.$route.params.id);
                renewOrder = true;
            }

            // get list of users
            var model = this;
            userService.getUsers().then(response => {
                model.users = response.data;
            });

            this.readOrder(orderId, orderType, renewOrder, tempOrder);
        },

        readOrder(orderId, orderType, renewOrder, tempOrder) {
            this.loading = true;
            var payload = {
                orderId: orderId,
                orderType: orderType,
                renew: renewOrder,
                tempOrder: tempOrder,
                checkLocalStorage: true,
            };
            this.$store.dispatch("order/getOrder", payload).then(() => {
                this.orderSettings = this.typeSettings(this.order.OrderTypeId);
                this.orderTypeId = this.order.OrderTypeId;

                this.propertyType = this.orderSettings.JsonSettings.PropertyType;
                this.selectedUser = this.users.find(
                    item => item.Id == this.order.UserId
                );

                // for confirmed order we don't ask the user to agree with Terms and conditions
                if (this.order.Status >= 2) {
                    this.termsAgreed = true;
                }

                this.customOptions = JSON.parse(JSON.stringify(this.orderCustomOptions));

                if (this.customOptions == null) {
                    this.customOptions = {};
                }

                this.loading = false;
            });
        },

        user_changed(value) {
            this.selectedUser = value;
            this.setCurrentOrderUser(value.Id);
        },

        backButtonClick: function () {
            if (this.order.Status >= 2) {
                this.$router.push({ path: "/crm/orders/confirmed" });
            } else {
                this.$router.push({ path: "/crm/orders/request" });
            }
        },

        calculateOfferButtonClick: function () {
            if (!this.termsAgreed) {
                this.$refs["termsModal"].show();
            } else {
                this.calculateOffers();
            }
        },
        //
        termsAndConditionsAccepted: function () {
            this.$refs["termsModal"].hide();
            this.calculateOffers();
        },

        calculateOffers: function () {
            var model = this;
            if (this.validate()) {
                // property
                if (this.orderSettings.Description != 'RCA') {
                    model.cachingOffer = true;
                    this.$store
                        .dispatch("order/saveOrder")
                        .then(function (orderId) {
                            model.cachingOffer = false;
                            var redirectPath = "/crm/orders/confirmed";
                            model.$router.push({ path: redirectPath });
                        });
                } else {
                    // vehicle
                    model.cachingOffer = true;
                    this.$store
                        .dispatch("order/cacheOrder")
                        .then(function (cacheKey) {
                            model.setCurrentOrderCacheKey(cacheKey);
                            model.orderCachekey = cacheKey;
                            model.cachingOffer = false;
                            model.canSaveOffer = false;
                            model.offerSaved = false;
                            model.$refs.offersModal.show();
                        });
                }
            } else {
                model.$bvToast.toast(
                    "Eroare validare date. Verificati datele introduse.",
                    {
                        title: "Introducere date",
                        variant: "warning",
                        autoHideDelay: 3000
                    }
                );
            }
        },

        saveOfferButtonClick: function () {
            // save offers before save order
            this.setOffers(this.$refs.offersComponent.offers);

            var model = this;
            if (this.validate()) {
                this.saving = true;
                this.$store
                    .dispatch("order/saveTempOrder")
                    .then(function (tempOrderId) {
                        //model.hideOffersModal();
                        model.currentOrderId = tempOrderId;

                        model.setCurrentOrderId(0); // in case user saves again will be considered as a new order (because is a new offer)
                        model.saving = false;
                        model.offerSaved = true;

                        model.$bvToast.toast("Oferta salvata cu scuccess.", {
                            title: "Salvare oferta",
                            variant: "success",
                            autoHideDelay: 3000
                        });
                    });
            }
        },

        saveOrderButtonClick: function () {
            var model = this;
            if (this.validate()) {
                this.saving = true;
                this.$store.dispatch("order/saveOrder").then(function (order) {
                    model.saving = false;

                    model.$bvToast.toast("Comanda salvata cu scuccess.", {
                        title: "Salvare comanda",
                        variant: "success",
                        autoHideDelay: 3000
                    });
                    // go back
                    model.$router.go(-1);
                    //model.$router.push({ path: "/crm/orders/confirmed" });
                });
            }
        },

        hideOffersModal() {
            this.$refs["offersModal"].hide();
        },

        getPdfOffer: function () {
            window.location.href = "api/Order/Pdf/" + this.currentOrderId;
        },

        onOrderSaved: function () {
            this.$router.push({ name: 'ConfirmedOrderList' });
        }
    },

    watch: {
        '$route.params.type': {
            handler: function (type, oldType) {
                if (oldType != undefined && oldType != type) {
                    this.loadOrder();
                }
            },
        },
        customOptions: {
            handler: function (val, oldVal) {
                this.setCustomOptions(val);
            },
            deep: true
        },
    }
};
